module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAeCAYAAAAl+Z4RAAABRElEQVRIS6WVOU7EQBBFX+UESCwnIGOLSIjgBMBwACQCbsE9CLkEDCAgRhyBZQKWO0BCoRq1R+122d0Nlhy5/6v/q1Vl4Z+PmF5VV4CJiPzU8kRVt4BH4AbYE5GvGogB5oAHYPUvkCbCMnAHrAHXwH6pkykg9GEJuK+FzAAO5Ao4yDlpASKIxVkHDGJxvvsa2wHUQlyAAxmHOB0nvYAAWQy3swG4kEGAA7kERnFPsoAIcgtsAi1IEcCBXACH5qQYECALoSfmxCCjKkB0O0/APHBcBVBVO38GnABvwHYxwBHvisikCNAntkhZwJA4C0jE78CO2Y4Ha2gW4oaZ2DK/plPZN41FYjdCYvsj2O5UbpykGymunBW3HDiVLfNLbsU3WzmtXCSeOkgqf4bM2cqzHqjqEXAOVIsbB/ZHOrVXRJ5zmdPvv5xwqJhOg3BNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/sound/arrow_right_btn.png
// module id = 83
// module chunks = 150